import React, { FC, memo } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { texts } from '../constants'
import { IAboutProps } from '../types'
import Styled from '../base/styles'

const { ChipsBlock } = Styled

const InstitutionAbout: FC<IAboutProps> = ({
  isShowMilitaryTrainingCenter,
  institutionTypeName,
  description,
  chipsData,
  showAbout,
  institutionType,
}) => {
  const { foundYear, hasHostel, isMilitaryChair } = chipsData
  const {
    title,
    chips: { founded, military, hostel },
  } = texts

  return (
    <>
      <Heading h2={title} spacing='small' />

      <ChipsBlock>
        {foundYear && institutionTypeName && (
          <Chips color='blue'>
            {institutionTypeName} {institutionType === 3 ? `основана в` : founded}{' '}
            {foundYear}
          </Chips>
        )}

        {isShowMilitaryTrainingCenter && showAbout && (
          <Chips color='blue'>
            {isMilitaryChair && `Есть ${military[1]}`}

            {!isMilitaryChair && `Нет ${military[0]}`}
          </Chips>
        )}

        {showAbout && (
          <Chips color='blue'>
            {hasHostel && `Есть ${hostel[1]}`}

            {!hasHostel && `Нет ${hostel[0]}`}
          </Chips>
        )}
      </ChipsBlock>
      <Spacing spacing='large' />

      {description && <Text>{description}</Text>}
    </>
  )
}

export default memo(InstitutionAbout)
